import React, { Component } from 'react';
import ReactPaginate from 'react-paginate';
import { Link } from 'react-router-dom';
import '../Pagination.css';
import '../common/MdPage.css';
import * as constantClass from '../fileWithConstants';
import { createPagedGridController } from '../../hooks/pagedGridClassAdapter';
import * as correlatividadesService from '../../services/correlatividades/correlatividadesService';
import { classifyCorrelatividadesError } from '../../services/correlatividades/correlatividadesDto';
import { ConfirmDialog } from '../common/ConfirmDialog';
import {
  buildStandardRowActions,
  MdRowActions,
  MdTableActionsCell,
  MdTableCell,
} from '../common/MdRowActions';
import { PlusIcon, SearchIcon } from '../common/mdPageIcons';

function formatMateriaCell(codigo, nombre) {
  return `${codigo} - ${nombre}`;
}

export class MDCorrelatividadRendir extends Component {
  static displayName = MDCorrelatividadRendir.name;

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      searchInput: '',
      perPage: 10,
      paginationData: [],
      pageCount: 0,
      forcePage: 0,
      showErrorMessage: false,
      errorMessage: '',
      successMessage: '',
      deletingId: null,
      pendingDelete: null,
    };
    this.grid = createPagedGridController({
      fetchPage: (query) => correlatividadesService.listCorrelatividadesRendir(query),
      defaultPageSize: 10,
      onChange: (gridState) => this.applyGridState(gridState),
    });
    this.searchInputRef = React.createRef();
  }

  applyGridState(gridState) {
    this.setState({
      paginationData: gridState.items,
      pageCount: gridState.pageCount,
      searchInput: gridState.search,
      perPage: gridState.pageSize,
      loading: gridState.loading,
      forcePage: gridState.forcePage,
    });
  }

  async componentDidMount() {
    const canAccess = await constantClass.canAccess('WWCorrelatividadesRendir');
    if (canAccess) {
      this.populateData();
    }
  }

  handlePageClick = (e) => {
    this.grid.handlePageClick(e).catch((error) => this.handleCorrelatividadesError(error));
  };

  handleSearchInputChange = (e) => {
    const searchInput = e.target.value;
    const cleared = searchInput.trim() === '';
    this.setState({ searchInput, successMessage: '', showErrorMessage: false, errorMessage: '' });
    if (cleared && this.grid.getState().search.trim() !== '') {
      this.grid.clearSearchIfNeeded(this.grid.getState().search).catch((error) => this.handleCorrelatividadesError(error));
    }
  };

  handleSearchSubmit = (e) => {
    e.preventDefault();
    const search = (this.searchInputRef.current
      ? this.searchInputRef.current.value
      : this.state.searchInput).trim();
    this.setState({ searchInput: search });
    this.grid.submitSearch(search).catch((error) => this.handleCorrelatividadesError(error));
  };

  handleRemoveItem = (item) => {
    if (this.state.deletingId) {
      return;
    }
    this.setState({
      pendingDelete: {
        id: item.correlatividadRendirCod,
        materia: formatMateriaCell(item.materiaCarreraMostrar, item.materiaCarreraNombre),
        correlativa: formatMateriaCell(item.materiaCarreraMostrar2, item.materiaCarreraNecesaria),
      },
    });
  };

  handleCancelDelete = () => {
    if (this.state.deletingId) {
      return;
    }
    this.setState({ pendingDelete: null });
  };

  handleConfirmDelete = () => {
    const { pendingDelete } = this.state;
    if (!pendingDelete || this.state.deletingId) {
      return;
    }
    this.deleteItem(pendingDelete.id);
  };

  renderTable(items) {
    return (
      <div className="md-page__table-card">
        <table className="md-page__table md-page__table--actions-fixed" aria-labelledby="md-crendir-title">
          <thead>
            <tr>
              <th scope="col">Materia</th>
              <th scope="col">Materia necesaria</th>
              <th scope="col">Condición</th>
              <th scope="col">Carrera</th>
              <th scope="col" className="md-page__table__actions-header" aria-label="Acciones" />
            </tr>
          </thead>
          <tbody>
            {items.map((item) => (
              <tr key={item.correlatividadRendirCod}>
                <MdTableCell>{formatMateriaCell(item.materiaCarreraMostrar, item.materiaCarreraNombre)}</MdTableCell>
                <MdTableCell>{formatMateriaCell(item.materiaCarreraMostrar2, item.materiaCarreraNecesaria)}</MdTableCell>
                <MdTableCell>{item.correlatividadRendirCondicion}</MdTableCell>
                <MdTableCell>{item.carreraNombre}</MdTableCell>
                <MdTableActionsCell>
                  <MdRowActions
                    items={buildStandardRowActions({
                      editTo: '/update-crendir/' + item.correlatividadRendirCod + '/0',
                      onDelete: () => this.handleRemoveItem(item),
                      deleteDisabled: this.state.loading || this.state.deletingId === item.correlatividadRendirCod,
                      deleteLabel: this.state.deletingId === item.correlatividadRendirCod ? 'Eliminando...' : 'Borrar',
                      detailTo: '/update-crendir/' + item.correlatividadRendirCod + '/1',
                    })}
                  />
                </MdTableActionsCell>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  render() {
    const isBusy = this.state.loading;
    const listLoading = this.state.loading && !this.state.deletingId;
    const { pendingDelete } = this.state;

    const contents = listLoading
      ? <p className="md-page__loading"><em>Cargando datos...</em></p>
      : this.renderTable(this.state.paginationData);

    return (
      <div className="md-page md-crendir">
        <div className="md-page__header">
          <h1 id="md-crendir-title" className="md-page__title">Manejar Datos de Correlatividades para Rendir</h1>
        </div>

        {!this.state.showErrorMessage ? (
          <div className="md-page__toolbar">
            <Link className="md-page__action-link" to="/add-crendir">
              <PlusIcon />
              Nueva Correlatividad para Rendir
            </Link>
          </div>
        ) : null}

        <div className="md-page__feedback" aria-live="polite" role="status">
          {this.state.showErrorMessage ? (
            <div className="md-page__error" role="alert">{this.state.errorMessage}</div>
          ) : null}
          {this.state.successMessage ? (
            <div className="md-page__success">{this.state.successMessage}</div>
          ) : null}
        </div>

        {!this.state.showErrorMessage ? (
          <>
            <form className="md-page__search-row" onSubmit={this.handleSearchSubmit}>
              <div className="md-page__search-wrap">
                <span className="md-page__search-icon">
                  <SearchIcon />
                </span>
                <input
                  ref={this.searchInputRef}
                  className="md-page__search-input"
                  type="text"
                  name="search"
                  autoComplete="off"
                  disabled={isBusy}
                  placeholder="Ingrese materia o materia necesaria..."
                  value={this.state.searchInput}
                  onChange={this.handleSearchInputChange}
                />
              </div>
              <button type="submit" className="md-page__search-btn" disabled={isBusy}>
                Buscar
              </button>
            </form>

            {contents}

            {!listLoading && this.state.pageCount > 1 ? (
              <div className="md-page__pagination">
                <ReactPaginate
                  previousLabel="Anterior"
                  nextLabel="Siguiente"
                  breakLabel="..."
                  breakClassName="break-me"
                  pageCount={this.state.pageCount}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={5}
                  onPageChange={this.handlePageClick}
                  forcePage={this.state.forcePage}
                  containerClassName="pagination"
                  subContainerClassName="pages pagination"
                  activeClassName="active"
                />
              </div>
            ) : null}
          </>
        ) : null}

        <ConfirmDialog
          open={Boolean(pendingDelete)}
          title="Eliminar correlatividad"
          message="Esta acción eliminará la correlatividad para rendir y no se puede deshacer."
          detail={
            pendingDelete
              ? `${pendingDelete.materia} → ${pendingDelete.correlativa}`
              : ''
          }
          confirmLabel="Eliminar"
          cancelLabel="Cancelar"
          variant="danger"
          loading={Boolean(this.state.deletingId)}
          onConfirm={this.handleConfirmDelete}
          onCancel={this.handleCancelDelete}
        />
      </div>
    );
  }

  handleCorrelatividadesError(error) {
    const outcome = classifyCorrelatividadesError(error);
    if (outcome.type === 'timeout') {
      constantClass.RedirectToLogin();
      return;
    }
    this.setState({
      showErrorMessage: true,
      errorMessage: outcome.message,
      loading: false,
    });
  }

  async populateData() {
    try {
      await this.grid.load();
    } catch (error) {
      this.handleCorrelatividadesError(error);
    }
  }

  async deleteItem(id) {
    this.setState({ deletingId: id, showErrorMessage: false, errorMessage: '' });
    try {
      await correlatividadesService.deleteCorrelatividadRendir(id);
      this.setState({ successMessage: 'El registro se eliminó correctamente.', pendingDelete: null });
      await this.grid.reloadAfterDelete(this.state.paginationData.length);
    } catch (error) {
      this.handleCorrelatividadesError(error);
    } finally {
      this.setState({ deletingId: null });
    }
  }
}
